export const version = "1.7.17";
export const channel = "core";
export const gitcommit = "unknown";
